import { render } from "./AdmListaEmpresaView.vue?vue&type=template&id=5bedae0a"
import script from "./AdmListaEmpresaView.vue?vue&type=script&lang=js"
export * from "./AdmListaEmpresaView.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Projeto_ELITE\\VUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__